"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TableHead = _interopRequireDefault(require("./TableHead"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  className: _propTypes["default"].string,
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    dataIndex: _propTypes["default"].string.isRequired,
    key: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string
  })),
  dataSource: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string
  })),
  rowKey: _propTypes["default"].string,
  size: _propTypes["default"].string,
  title: _propTypes["default"].string
};
var defaultProps = {
  columns: [],
  dataSource: [],
  rowKey: 'key',
  size: '',
  title: ''
};

var Table = function Table(_ref) {
  var columns = _ref.columns,
      dataSource = _ref.dataSource,
      size = _ref.size,
      title = _ref.title,
      rowKey = _ref.rowKey,
      className = _ref.className,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["columns", "dataSource", "size", "title", "rowKey", "className"]);

  var classes = (0, _classnames["default"])('grv-table', {
    'grv-table--small': size === 'small',
    'grv-table--tiny': size === 'tiny'
  }, className);
  return /*#__PURE__*/_react["default"].createElement("table", _extends({}, otherProps, {
    className: classes
  }), title !== '' ? /*#__PURE__*/_react["default"].createElement("caption", {
    className: "grv-table__caption"
  }, title) : null, /*#__PURE__*/_react["default"].createElement(_TableHead["default"], {
    columns: columns
  }), /*#__PURE__*/_react["default"].createElement("tbody", {
    className: "grv-table__body"
  }, dataSource.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      className: "grv-table__row",
      key: row[rowKey]
    }, columns.map(function (column) {
      return /*#__PURE__*/_react["default"].createElement("td", {
        className: "grv-table__cell",
        key: column.key
      }, row[column.dataIndex]);
    }));
  })));
};

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
var _default = Table;
exports["default"] = _default;